// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VZTD","col":"styles_col__23gTc"};